module.exports = __webpack_public_path__ + "4d54cf592a7ea8033775cf955f3aaa50.svg";